import { isAuthenticated } from '../core/auth';
import App from './app';
import SignIn from './pages/sign-in';
import SignUp from './pages/sign-up'
import OnOffCampus from './pages/on-off-campus'
import HousingGroup from './pages/housing-group'
import HousingPreferences from './pages/housing-preferences'
import HousingResults from './pages/housing-results'
import Tasks from './pages/tasks';
import MealPlan from './pages/meal-plan';
import HousingClosed from './pages/housing-closed'


export const paths = {
  ROOT: '/',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  TASKS: '/tasks',
  ON_OFF_CAMPUS: '/',
  ON_OFF_CAMPUS_COPY: '/housing-location',
  HOUSING_GROUP: '/housing-group',
  HOUSING_PREFERENCES: '/housing-preferences',
  HOUSING_RESULTS: '/housing-results',
  MEAL_PLAN: '/meal-plan'
};


const requireAuth = getState => {
  return (nextState, replace) => {
    if (!isAuthenticated(getState())) {
      replace(paths.SIGN_IN);
    }
  };
};

const requireUnauth = getState => {
  return (nextState, replace) => {
    if (isAuthenticated(getState())) {
      replace(paths.ON_OFF_CAMPUS);
    }
  };
};


export const getRoutes = getState => {
  return {
    path: paths.ROOT,
    component: App,
    childRoutes: [
      {
        indexRoute: {
          component: OnOffCampus,
          onEnter: requireAuth(getState)
        }
      },
      {
        path: paths.SIGN_IN,
        component: SignIn,
        onEnter: requireUnauth(getState)
      },
      // {
      //   path: paths.SIGN_UP,
      //   component: SignUp,
      //   onEnter: requireUnauth(getState)
      // },
      {
        path: paths.TASKS,
        component: Tasks,
        onEnter: requireAuth(getState)
      },
      {
        path: paths.HOUSING_GROUP,
        component: HousingGroup,
        onEnter: requireAuth(getState)
      },
      {
        path: paths.HOUSING_PREFERENCES,
        component: HousingPreferences,
        onEnter: requireAuth(getState)
      },
      {
        path: paths.HOUSING_RESULTS,
        component: HousingResults,
        onEnter: requireAuth(getState)
      },
      {
        path: paths.ON_OFF_CAMPUS_COPY,
        component: OnOffCampus,
        onEnter: requireAuth(getState)
    },
    {
      path: paths.MEAL_PLAN,
      component: MealPlan,
      onEnter: requireAuth(getState)
    }
    ]
  };
};



// WEBPACK FOOTER //
// ./src/views/routes.js